import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import './InvoiceSearchFilterStyle.css';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import CustomAddButton from '../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { get_worksite_with_out_pagination } from '../../../../config/Worksite/siteApis';
import { get_technology_with_out_pagination } from '../../../../config/Resource/technologyApis';
import { get_workforce_with_out_pagination } from '../../../../config/Resource/workforceApis';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { TbCreditCardPay } from "react-icons/tb";
import { moveToClientInvoiceStatus, moveToClientStatus, paymentStatusOptions } from '../../../../utils/constants';
import { BsFillSendFill } from 'react-icons/bs';
import { TbStatusChange } from "react-icons/tb";
import { get_all_invoice_status } from '../../../../config/ScheduleReportApis/scheduleReportApis';

function InvoiceSearchFilter({ handleClearSelectedIds, currentDropdown, tableTitle, searchFilter, handlPaymentSubmitModal, handleSubmitModal
    , on_change_value, on_page_count_update,
    is_Mark_As_Paid, is_SendTo_Client, handleCurrentDropdownValues

}) {

    const [allInvoiceStatus, setAllInvoiceStatus] = useState([]);

    const [technologyListing, setTechnologyListing] = useState([]);
    // const [allInvoiceStatus, setWorksiteListing] = useState([]);



    // FETCH fetchAllInvoiceStatus
    const fetchAllInvoiceStatus = async () => {
        try {
            const response = await get_all_invoice_status();

            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response?.data?.map((item) => ({
                    label: item?.IS_Name,
                    value: item?.IS_Id
                }));

                // Set the transformed data to the state
                setAllInvoiceStatus(transformedData || []);
            } else {
                setAllInvoiceStatus([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setAllInvoiceStatus([]);
        }
    };

    // FETCH WORKSITES 
    // const fetchSites = async () => {
    //     try {
    //         const response = await get_worksite_with_out_pagination();

    //         if (response?.status === "success") {
    //             // Transform data into the desired format with label and value
    //             const transformedData = response.data.data?.map((item) => ({
    //                 label: item?.worksiteName,
    //                 value: item?.WorksiteID
    //             }));

    //             // Set the transformed data to the state
    //             setWorksiteListing(transformedData || []);
    //         } else {
    //             setWorksiteListing([]);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching :', error);
    //         setWorksiteListing([]);
    //     }
    // };
    const fetchTechnologies = async () => {
        try {
            const response = await get_technology_with_out_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response?.data?.data?.map((item) => ({
                    label: item?.TechnologiesName,
                    value: item?.TechnologiesTypeId
                }));

                // Set the transformed data to the state
                setTechnologyListing(transformedData || []);
            } else {
                setTechnologyListing([]);
            }
        } catch (error) {
            console.error('Error fetching technologies:', error);
            setTechnologyListing([]);
        }
    };
    // FOR GET TECHNOLOGIES FROM LIST
    useEffect(() => {
        // fetchSites()
        // fetchWorkforce()
        fetchAllInvoiceStatus();
    }, []);


    const formik = useFormik({
        initialValues: {
            invoice_number: '',
            submitted_by: '',
            submitted_from: '',
            submitted_to: '',
            // TechnologyId: '',
            // EmployeeId: '',
            // EquipmentID: '',
            invoice_status: '',

            PaymentStatus: 0,
            sentToClient: 0,
        },
    });
    const resetFilter = () => {
        formik.resetForm();
        handleClearSelectedIds()
        on_change_value(1)
        on_page_count_update(25)
        searchFilter(
            {
                invoice_number: '',
                submitted_by: '',
                submitted_from: '',
                submitted_to: '',
                // TechnologyId: '',
                // EmployeeId: '',
                // EquipmentID: '',
                invoice_status: '',
                PaymentStatus: 0,
                sentToClient: 0,
            }
        )
    }

    const breadcrumbs = ['Finance', tableTitle];

    return (
        <div className="schedule-search-filter-container">
            <div className="schedule-search-filter-sub-container">
                <div className="schedule-search-filter-header">
                    <div className="schedule-search-filter-left">
                        <div className="schedule-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                    <div className="invoice-search-filter-right">

                        {/* <>
                            {is_SendTo_Client && Number(currentDropdown?.sentToClient) === 0 && Number(currentDropdown?.PaymentStatus) === 0 && (
                                <CustomAddButton
                                    label="Send To Client"
                                    onClick={handleSubmitModal}
                                    Icon={BsFillSendFill}
                                />
                            )}

                            {is_Mark_As_Paid && Number(currentDropdown?.sentToClient) === 1 && Number(currentDropdown?.PaymentStatus) === 0 && (
                                <CustomAddButton
                                    label="Mark as Paid"
                                    onClick={handlPaymentSubmitModal}
                                    Icon={TbCreditCardPay}
                                />
                            )}
                        </> */}
                        <div className='action-button-flex-gap-5' >
                            <CustomAddButton
                                label="Send To Client"
                                onClick={handleSubmitModal}
                                Icon={BsFillSendFill}
                                isDisable={!(is_SendTo_Client &&
                                    Number(currentDropdown?.sentToClient) === 0 &&
                                    Number(currentDropdown?.PaymentStatus) === 0)}
                            />

                            <CustomAddButton
                                label="Change Status"
                                onClick={handlPaymentSubmitModal}
                                Icon={TbStatusChange}
                                isDisable={!(
                                    is_Mark_As_Paid &&
                                    Number(currentDropdown?.sentToClient) === 1 &&
                                    Number(currentDropdown?.PaymentStatus) === 0
                                )}
                            />
                        </div>
                    </div>
                </div>
                <div className="search-layout-wrapper">
                    <div className="search-filter-container">
                        <div className="search-inputs-fields">
                            {/* Search fields */}
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="invoice_number"
                                    placeholder="Enter Invoice Number"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.invoice_number}
                                    width="200px"
                                />
                            </Grid>

                            {/* Search submitted_by  */}
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="submitted_by"
                                    placeholder="Search by name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.submitted_by}
                                    width="200px"
                                />
                            </Grid>

                            {/* <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="TechnologyId"
                                    placeholder="Select Technology"
                                    options={technologyListing}
                                    value={technologyListing.find((tech) => tech.value === formik.values.TechnologyId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("TechnologyId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.TechnologyId && Boolean(formik.errors.TechnologyId)}
                                    helperText={formik.touched.TechnologyId && formik.errors.TechnologyId}
                                    isDisabled={false}
                                    isMulti={false} // Single select
                                    width="200px"
                                />
                            </Grid> */}

                            {/* <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="EmployeeId"
                                    placeholder="Select Workforce"
                                    options={workforceListing}
                                    value={workforceListing.find((employee) => employee.value === formik.values.EmployeeId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("EmployeeId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.EmployeeId && Boolean(formik.errors.EmployeeId)}
                                    helperText={formik.touched.EmployeeId && formik.errors.EmployeeId}
                                    isDisabled={false}
                                    isMulti={false} // Single select
                                    width="200px"
                                />
                            </Grid> */}

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="invoice_status"
                                    placeholder="Select Status"
                                    options={allInvoiceStatus}
                                    value={allInvoiceStatus?.find((worksite) => worksite.value === formik.values.invoice_status) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("invoice_status", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Single select
                                    width="300px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="sentToClient"
                                    placeholder="Select Status"
                                    options={moveToClientInvoiceStatus}
                                    value={
                                        moveToClientInvoiceStatus?.find(option => option?.value === formik?.values?.sentToClient) ||
                                        moveToClientInvoiceStatus?.find(option => option?.value === 0)
                                    }
                                    onChange={(selectedOption) => {
                                        handleClearSelectedIds()
                                        formik.setFieldValue("sentToClient", selectedOption ? selectedOption.value : 0);
                                        handleCurrentDropdownValues({ sentToClient: selectedOption ? selectedOption.value : 0, PaymentStatus: 0 })
                                    }}
                                    onBlur={formik.handleBlur}
                                    isClearable={false}
                                    isMulti={false} // Set to false for single-select
                                    width="250px"
                                />
                            </Grid>

                            {Number(formik.values?.sentToClient) === 1 && (
                                <Grid item xs={12} sm={6} md={2}>
                                    <CustomSelectDropdown
                                        name="PaymentStatus"
                                        placeholder="Select Status"
                                        options={paymentStatusOptions}
                                        value={
                                            paymentStatusOptions?.find(option => option?.value === formik?.values?.PaymentStatus) ||
                                            paymentStatusOptions?.find(option => option?.value === 0)
                                        }
                                        onChange={(selectedOption) => {
                                            formik.setFieldValue("PaymentStatus", selectedOption ? selectedOption.value : '');
                                            handleCurrentDropdownValues({ sentToClient: formik?.values?.sentToClient, PaymentStatus: selectedOption ? selectedOption.value : 0 })

                                        }}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.PaymentStatus && Boolean(formik.errors.PaymentStatus)}
                                        helperText={formik.touched.PaymentStatus && formik.errors.PaymentStatus}
                                        isClearable={false}
                                        isMulti={false}
                                        width="100%"
                                    />
                                </Grid>
                            )}



                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="submitted_from"
                                    label="From Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("submitted_from", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.submitted_from, "DD-MM-YYYY")}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="submitted_to"
                                    label="End Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("submitted_to", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.submitted_to, "DD-MM-YYYY")}
                                    minDate={dayjs(formik.values.submitted_from, "DD-MM-YYYY")} // Set minimum date

                                    width="200px"
                                />
                            </Grid>
                        </div>
                        {/* Search Button */}
                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                onClick={() => {
                                    handleClearSelectedIds()
                                    on_change_value(1)
                                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                }}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>

                    </div>
                </div>


            </div>
        </div>
    );
}

export default InvoiceSearchFilter;
